import PaymentHandlingAndroid from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/paymentHandling.mdx";
import PaymentMethodOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/paymentMethodOptions.mdx";
import PrimerUIOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/uiOptions.mdx";
import PrimerDebugOptions from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/debugOptions.mdx";
import ClientSessionCachingEnabledAndroid from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/clientSessionCachingEnabled.mdx";
import ApiVersionAndroid from "../../../../content/sdk/android/2.x.x/common/settings/_primerSettings/apiVersion.mdx";
import * as React from 'react';
export default {
  PaymentHandlingAndroid,
  PaymentMethodOptions,
  PrimerUIOptions,
  PrimerDebugOptions,
  ClientSessionCachingEnabledAndroid,
  ApiVersionAndroid,
  React
};